import React from 'react';
import { FiShield, FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export default function AccessDeniedPage({ message, requires }) {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-[60vh] place-items-center">
      <div className="max-w-md rounded-lg border border-slate-200 bg-white p-8 text-center shadow-card">
        <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-danger/10 text-danger">
          <FiShield size={24} />
        </div>
        <h2 className="text-lg font-semibold text-ink">Access Denied</h2>
        <p className="mt-2 text-sm text-ink-muted">
          {message ||
            'You do not have permission to view this page. Contact your administrator if you believe this is a mistake.'}
        </p>
        {requires && (
          <div className="mt-4 rounded bg-slate-50 p-3 text-left text-xs text-ink-muted">
            <div className="font-semibold text-ink">Required access</div>
            {requires.roles && (
              <div>Roles: {requires.roles.join(', ')}</div>
            )}
            {requires.depts && (
              <div>Departments: {requires.depts.join(', ')}</div>
            )}
          </div>
        )}
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mt-6 inline-flex items-center gap-2 rounded bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-light"
        >
          <FiArrowLeft /> Go back
        </button>
      </div>
    </div>
  );
}
